export const STRATEGY_LABELS: Record<string, string> = {
  'level-break-and-retest': 'LB_AA',
  'lbar-ab': 'LB_AB',
  'lbar-ac': 'LB_AC',
  'lbar-ad': 'LB_AD',
  'lr-aa': 'LR_AA',
  'lbar-ae': 'LB_AE',
  'lbar-af': 'LB_AF',
  'lbar-ag': 'LB_AG',
  'lbar-ah': 'LB_AH',
  'lbar-ai': 'LB_AI',
  'lbar-aj': 'LB_AJ',
};

export const getStrategyLabel = (strategyName?: string, strategyType?: string) => {
  const normalizedStrategyName = String(strategyName || '').trim();
  if (normalizedStrategyName) {
    return normalizedStrategyName;
  }

  const normalizedStrategyType = String(strategyType || '').trim();
  if (!normalizedStrategyType) {
    return '-';
  }

  if (normalizedStrategyType.startsWith('custom:')) {
    return 'Custom Strategy';
  }

  return STRATEGY_LABELS[normalizedStrategyType] || normalizedStrategyType;
};
